import React, { Component } from 'react';

const Combo = (props)=> {
    let {infoData, selectCombo, selecciones, campo, titulo, validaCamposEdicion, mensajeErrorValidacion, modFormato, width100} = props;
    let black = false
    let firstOption = {Id:0,Descripcion: "Seleccione..."}
                
    let opcionSeleccionadaEncontrada = infoData.filter((e)=>e.Id==selecciones[campo])[0]
    if(opcionSeleccionadaEncontrada){
        firstOption = {Id:opcionSeleccionadaEncontrada.Id, Descripcion:opcionSeleccionadaEncontrada.Descripcion}
    }        
    
    if(selecciones[campo] == firstOption.Id) black = true

    let objetoStyle  = {};

    if(width100){
        objetoStyle.width="100%";
        objetoStyle.borderColor="#afbaca";
    } 

    if(black) objetoStyle.color="black"
    
    return (
        <div className={!modFormato ? (validaCamposEdicion && !width100 ? "bottom-separator-marca" : "bottom-separator-xxs") : ((validaCamposEdicion ? "bottom-separator-marca" : "bottom-separator-xxs") + " "+ modFormato )}>
            <label className="label-primary">{titulo}</label>
            <div className="">
                <div>
                    <select className={"comboClienteModificacion "} style={objetoStyle} value={selecciones[campo]} onChange={(event) => {
                        const index = event.target.selectedIndex;
                        const value = event.target.options[index].value;
                        selectCombo(campo, value );
                    }}>
                        <option  key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option> 
                        {infoData.length>0 && infoData.map( (item,index) => {return <option style={{color:"black"}} key={index} value={item.Id}>{item.Descripcion}</option>} )}}
                    </select>
                </div>
            </div>
                {validaCamposEdicion == false && <label className='error'>{mensajeErrorValidacion}</label>}           
        </div>
    );
}

export default Combo;